import { render } from "./CartBuyer.vue?vue&type=template&id=07be998a"
import script from "./CartBuyer.vue?vue&type=script&lang=js"
export * from "./CartBuyer.vue?vue&type=script&lang=js"

import "./CartBuyer.vue?vue&type=style&index=0&id=07be998a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__